import { ReactNode } from 'react'
import { Box, BoxProps, Message } from 'theme-ui'

type ErrorMessageProps = BoxProps & {
  children?: ReactNode | string | undefined | null | false
}

export const ErrorMessage = ({ children, ...rest }: ErrorMessageProps) => (
  <Box
    sx={{
      pt: 2,
      pb: 3,
      minHeight: 40,
    }}
    {...rest}
  >
    <Message variant="messages.error">{children}</Message>
  </Box>
)
